import { render, staticRenderFns } from "./fotor-default.vue?vue&type=template&id=7c9db334"
import script from "./fotor-default.vue?vue&type=script&lang=js"
export * from "./fotor-default.vue?vue&type=script&lang=js"
import style0 from "./fotor-default.vue?vue&type=style&index=0&id=7c9db334&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FotorFullLoading: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/common/mobile/FotorFullLoading.vue').default,FotorToastLoading: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/common/mobile/FotorToastLoading.vue').default,FotorDialogMsg: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/common/mobile/FotorDialogMsg.vue').default,FotorToast: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/common/mobile/FotorToast.vue').default,FotorConfirm: require('/root/builds/BuRzTR46/1/fotor-mobile/frontend/fotor-h5-website/components/common/mobile/FotorConfirm.vue').default})
